import { SELECTED_REQUESTERID } from "./type"

export const selectRetailerRequesterId=(data)=>{
    return{
        type: SELECTED_REQUESTERID,
        payload: data

    }
}
